import { render, staticRenderFns } from "./Indexgroup.vue?vue&type=template&id=63c753e7&scoped=true&"
import script from "./Indexgroup.vue?vue&type=script&lang=js&"
export * from "./Indexgroup.vue?vue&type=script&lang=js&"
import style0 from "./Indexgroup.vue?vue&type=style&index=0&id=63c753e7&prod&lang=scss&scoped=true&"
import style1 from "./Indexgroup.vue?vue&type=style&index=1&id=63c753e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c753e7",
  null
  
)

export default component.exports